import React from 'react';
// Components
import {
  ABDL_FORM_PAGE_URL,
  ABOUT_PAGE_URL,
  DOM_FORM_PAGE_URL,
} from '../../utils/Routes';
import { CompanyEmailAddress, CompanyPhoneNumber } from '../../utils/Constants';
import { Link } from 'react-router-dom';

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full pb-12 pt-12'>
      <section className='grid w-full'>
        <div className='grid w-full px-6 lg:container lg:mx-auto'>
          <div className='grid gap-y-8'>
            {/* Intro with form links */}
            <div>
              <p>
                <strong>HOW TO BOOK YOUR SESSION:</strong> Begin by using the
                appropriate form to submit your request. If you’re seeking a
                classic power exchange, please complete the{' '}
                <Link
                  to={DOM_FORM_PAGE_URL}
                  aria-label='Open Domination Form'
                  title='Open Domination Form'
                >
                  <strong>DOMINATION FORM</strong>
                </Link>
                . If your desires lean toward age play, nurturing control, or
                Adult Baby/Nappy Diaper Lover experiences, then you’ll need the{' '}
                <Link
                  to={ABDL_FORM_PAGE_URL}
                  aria-label='Open Adult Baby Form'
                  title='Open Adult Baby Form'
                >
                  <strong>ADULT BABY FORM</strong>
                </Link>
                . Submitting the correct form is your first act of obedience.
              </p>
            </div>

            {/* EMAIL AND PHONE */}
            <div className='grid gap-y-2 pt-4 justify-center text-center font-semibold'>
              <a
                href={`mailto:${CompanyEmailAddress}`}
                aria-label={`Email ${CompanyEmailAddress}`}
                title={`Email ${CompanyEmailAddress}`}
              >
                Email: {CompanyEmailAddress}
              </a>
              <a
                href={`tel:${CompanyPhoneNumber}`}
                aria-label={`Call ${CompanyPhoneNumber}`}
                title={`Call ${CompanyPhoneNumber}`}
              >
                Call: {CompanyPhoneNumber}
              </a>
            </div>

            <div className='grid grid-rows-reg'>
              <h3 className='text-center font-semibold'>APPLY DIRECTLY WITH YOUR REQUESTS BY COMPLETING A FORM</h3>
            </div>
            <div className='grid lg:grid-cols-2 justify-center w-fit mx-auto gap-y-4 gap-x-6 text-colour6'>
              <Link
                to={DOM_FORM_PAGE_URL}
                aria-label='Open Domination Form'
                title='Open Domination Form'
              >
                <strong>DOMINATION FORM</strong>
              </Link>
              <Link
                to={ABDL_FORM_PAGE_URL}
                aria-label='Open Adult Baby Form'
                title='Open Adult Baby Form'
              >
                <strong>ADULT BABY FORM</strong>
              </Link>
            </div>

            <p>
              <strong>SESSION BOOKINGS:</strong> My time is precious—and so is
              yours. If you're booking a session to begin{' '}
              <strong>at least 48 hours in advance</strong>, your best chance is
              via the form system. I do not guarantee availability, especially
              for short notice or same-day requests, but you are welcome to try.
              Just understand that my Regular Tribute applies to all
              short-notice appointments, and you may not receive a response if
              I’m unavailable or otherwise engaged. The more notice you give,
              the better your chances of experiencing my world.
            </p>

            <p>
              For longer sessions such as overnights, extended training, or
              experiences requiring detailed planning, you may also email me
              directly at <strong>{CompanyEmailAddress}</strong>. Your subject
              line should clearly include the <strong>session type</strong> and
              the <strong>earliest date/time</strong> you're seeking. All the
              required information from the appropriate form must still be
              included, or your email may be filtered out as spam.
            </p>

            <p>
              You will receive an auto-reply when your email lands in the
              correct inbox—so{' '}
              <strong>always check your spam/junk folder</strong> and add my
              email to your whitelist.
            </p>

            <p>
              <strong>DEPOSITS & CONFIRMATION:</strong> A non-refundable deposit
              of <strong>20%</strong> of the session fee or a{' '}
              <strong>£50 minimum</strong> is required to reserve your time with
              me. The remaining balance must be paid in full before the booking
              is confirmed. Be certain that what you're seeking aligns with my
              offerings—visit my{' '}
              <Link
                to={ABOUT_PAGE_URL}
                aria-label='Open Interests Page'
                title='Open Interests Page'
              >
                <strong>INTERESTS</strong>
              </Link>{' '}
              page before you apply. If in doubt, ask first via email.
            </p>

            <p>
              <strong>SHORT-NOTICE BOOKINGS:</strong> If you're requesting a
              session within the next 48 hours, this is considered{' '}
              <strong>short-notice</strong>. You will need to email{' '}
              <strong>{CompanyEmailAddress}</strong>. Be aware: I may be
              unavailable and unable to reply, especially on busy days. My
              Special Rates and custom experiences are <em>not</em> available
              for short-notice requests. Regular Tributes always apply.
            </p>

            <p>
              <strong>PHONE & WHATSAPP:</strong> My number is{' '}
              <strong>{CompanyPhoneNumber}</strong>.{' '}
              <em>Unarranged calls will not be answered</em>. WhatsApp is
              available <em>by arrangement only</em>. Please be respectful of my
              boundaries when making contact.
            </p>

            <p>
              <span style={{ color: '#ff0000' }}>
                <strong>AND REMEMBER—CHECK YOUR SPAM FOLDER!</strong>
                <br />I don’t chase. It’s your responsibility to stay alert and
                attentive.
              </span>
            </p>

            <p>
              <span style={{ color: '#ff0000' }}>
                <strong>
                  USE THE FORMS FOR DOMINATION SESSIONS, ADULT BABY EXPERIENCES,
                  ONLINE TRAINING, SOCIAL TIME & MORE. OBEDIENCE BEGINS WITH
                  FOLLOWING SIMPLE INSTRUCTIONS.
                </strong>
              </span>
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default ContactPageMainContainer;
